'use strict';

var _ = require('underscore'),
    AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    UserStore = require('./UserStore'),
    { createStore, mergeIntoBag } = require('../utils/StoreUtils'),
    update = require('react/lib/update'),
    ServiceTypes = require('../constants/ServiceTypes');

var _serviceAccounts = {},
    _deleted = {},
    _authServiceTypes = [ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE],
    _allServiceTypes = [
      ServiceTypes.FACEBOOK,
      ServiceTypes.TWITTER,
      ServiceTypes.GOOGLE,
      ServiceTypes.TUMBLR
    ];

function get(id, allowDeleted) {
  var serviceAccount = _serviceAccounts[id];
  return (serviceAccount && (allowDeleted || !_deleted[serviceAccount.id])) ? serviceAccount : null;
}

function getByType(userId, serviceType, allowDeleted) {
  var serviceIds = UserStore.get(userId).services;

  return _.chain(serviceIds)
    .map(id => get(id, allowDeleted))
    .find(acc => acc && acc.serviceType === serviceType)
    .value();
}

function deleteByType(userId, serviceType) {
  var serviceAccount = getByType(userId, serviceType);
  if (serviceAccount) {
    _deleted[serviceAccount.id] = true;
  }
}

function restoreByType(userId, serviceType) {
  var serviceAccount = getByType(userId, serviceType, true);
  if (serviceAccount) {
    delete _deleted[serviceAccount.id];
  }
}

function isAuthService(acc) {
  return acc && _authServiceTypes.indexOf(acc.serviceType) !== -1;
}

var ServiceAccountStore = createStore({
  get(id) {
    return get(id);
  },

  getByType(userId, serviceType) {
    return getByType(userId, serviceType);
  },

  getUserVisibleServiceAccounts(userId) {
    return _.chain(_allServiceTypes)
      .map(serviceType => getByType(userId, serviceType))
      .compact()
      .filter(acc => !acc.hidden)
      .value();
  },

  getUserServiceAccounts(userId) {
    return _.chain(_allServiceTypes)
      .map(serviceType => [serviceType, getByType(userId, serviceType)])
      .object()
      .value();
  },

  getConnectedAuthServiceAccounts(userId) {
    var serviceIds = UserStore.get(userId).services;

    return _.chain(serviceIds)
      .map(id => get(id))
      .filter(acc => isAuthService(acc))
      .compact()
      .value();
  },

  isConnected(userId, serviceType) {
    return !!getByType(userId, serviceType);
  },

  isAuthService(userId, serviceType) {
    return isAuthService(getByType(userId, serviceType));
  }
});

ServiceAccountStore.dispatchToken = AppDispatcher.register(function (payload) {
  var action = payload.action,
      response = action.response,
      entities = response && response.entities,
      receivedServiceAccounts = entities && entities.serviceAccounts,
      serviceAccount;

  switch (action.type) {
  case ActionTypes.DISCONNECT_SERVICE_ACCOUNT:
    deleteByType(UserStore.getMe().id, action.serviceType);
    ServiceAccountStore.emitChange();
    break;

  case ActionTypes.DISCONNECT_SERVICE_ACCOUNT_ERROR:
    restoreByType(UserStore.getMe().id, action.serviceType);
    ServiceAccountStore.emitChange();
    break;

  case ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN:
  case ActionTypes.TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR:
    serviceAccount = getByType(UserStore.getMe().id, action.serviceType);
    _serviceAccounts[serviceAccount.id] = update(serviceAccount, {
      hidden: {
        $apply: (x) => !x
      }
    });
    ServiceAccountStore.emitChange();
    break;

  default:
    if (receivedServiceAccounts) {
      mergeIntoBag(_serviceAccounts, receivedServiceAccounts);
      ServiceAccountStore.emitChange();
    }
    break;
  }
});

module.exports = ServiceAccountStore;



/** WEBPACK FOOTER **
 ** ./stores/ServiceAccountStore.js
 **/